// update-ability.js
import ability from '@/config/ability.js'
import { alertToast } from '@/utilities/notification'
import { useAuthStore } from '@/stores/AuthStore'
import { useAuthorizationStore } from '@/stores/AuthorizationStore'
import { useCallCenterStore } from '@/stores/CallCenterStore'
import useApiRequest from '@/composables/useApiRequest'

export default async function updateAbility(routerInstance) {
  const authStore = useAuthStore()
  const authorizationStore = useAuthorizationStore()
  const callCenterStore = useCallCenterStore()

  const getPermissions = async () => {
    try {
      const permissionsApiRequest = useApiRequest()

      const response = await permissionsApiRequest.send({
        endpoint: `/v1/users/${authStore.details.id}/permissions`,
        method: 'GET'
      })

      if (!response.success) {
        throw new Error('updateAbility() - Error fetching data')
      }

      const roles = response.data.roles
      const abilities = response.data.permissions
      const accessAllowed = response.data.access
      const callCenters = response.data.callCenters

      ability.update(abilities)

      if (accessAllowed === undefined || accessAllowed.regions.length === 0) {
        routerInstance.push({ path: '/no-access', replace: true })
        return Promise.reject('No access allowed')
      } else {
        authorizationStore.updateRoles(roles)
        authorizationStore.updateAccessAllowed(accessAllowed)

        const accessSelected = JSON.parse(localStorage.getItem('accessSelected')) ?? {
          regions: [],
          manufacturers: [],
          groups: [],
          dealerships: []
        }

        if (!localStorage.getItem('accessSelected')) {
          if (accessAllowed.regions.length === 1) {
            accessAllowed.regions[0].isSelected = true
            accessSelected.regions.push(accessAllowed.regions[0].id)
          }
          if (accessAllowed.manufacturers.length === 1) {
            accessAllowed.manufacturers[0].isSelected = true
            accessSelected.manufacturers.push(accessAllowed.manufacturers[0].id)
          }
          if (accessAllowed.groups.length === 1) {
            accessAllowed.groups[0].isSelected = true
            accessSelected.groups.push(accessAllowed.groups[0].id)
          }
          if (accessAllowed.dealerships.length === 1) {
            accessAllowed.dealerships[0].isSelected = true
            accessSelected.dealerships.push(accessAllowed.dealerships[0].id)
          }
        }

        accessSelected.regions = accessSelected.regions.filter(region =>
          accessAllowed.regions.some(r => r.id === region)
        )
        accessSelected.manufacturers = accessSelected.manufacturers.filter(manufacturer =>
          accessAllowed.manufacturers.some(m => m.id === manufacturer)
        )
        accessSelected.groups = accessSelected.groups.filter(group => accessAllowed.groups.some(g => g.id === group))
        accessSelected.dealerships = accessSelected.dealerships.filter(dealership =>
          accessAllowed.dealerships.some(d => d.id === dealership)
        )

        localStorage.setItem('accessSelected', JSON.stringify(accessSelected))

        if (accessSelected.dealerships.length === 0 && authStore.details.userType !== 1) {
          routerInstance.push({ path: '/access', replace: true })
        }
      }

      // Update user's call center permissions
      callCenterStore.updateCallCenters(callCenters)

      return Promise.resolve()
    } catch (err) {
      console.error('ERROR:', err)
      alertToast('Permissions error', err.message, 'error')
      return Promise.reject(err)
    }
  }

  return getPermissions()
}
